export default __webpack_public_path__ + "static/media/banner-6.a4807d45.jpg";